
            import "data:text/css,.m-signingInIcon-be883263a6%7Bwidth:24px;height:24px%7D";
            const result = {"signingInIcon":"m-signingInIcon-be883263a6"};
            export default result;
          